module.exports = __webpack_public_path__ + "img/playstore.444b3f76.png";